
import { AttendanceAdjustResponse, AttendanceLogModel, AttendanceLogResponse, AttendanceModel, AttendanceResponse, DayStatusModel, DeptDataModel, DeptWiseDataModel, EmployeeAttendanceResponse, EmployeeDataModel, EmployeeDataModelResponse, EmployeeShiftAttendanceResponse, EmployeeShiftCountResponse, MonthAttendanceResponse, MonthAttnDataModel, ShiftWiseCountModel, ShiftWiseDataModel } from "@gtpl/shared-models/hrms";
import { Injectable } from "@nestjs/common";
import { AttendanceLogAdapter } from "./dto/attendance-log.adapter";
import { AttendanceLogRequest } from "./dto/attendance-log.request";
import { AttendanceAdapter } from "./dto/attendance.adapter";
import { AttendanceLogEntity } from "./entities/attendance-log.entity";
import { AttendanceLogRepository } from "./repository/attendance-log.repository";
import { AttendanceRepository } from "./repository/attendance.repository";
import { CommonResponse, EmployeeDto } from "@gtpl/shared-models/masters";
import { EmployeeAttendanceRequest } from "./dto/get-emp-attendance.request";
import { GlobalResponseObject, LeaveApprovalStatusEnum, UnitRequest } from "@gtpl/shared-models/common-models";
import { AttendanceHelperService } from "./attendance-helper.service";
import { Cron } from '@nestjs/schedule';
import { EmpCodeShiftRequest } from "./dto/emp-code-shift.request";
import { ShiftAttendanceRequest } from "./dto/shift-emp-count.request";
import { AttnCountModel } from "libs/shared-models/hrms/src/lib/attendance/attn-count.model";
import { AttendanceUpdateRequest } from "./dto/attn-update.request";
import { AttendanceEntity } from "./entities/attendance.entity";
import { EmployeeAttDateRequest } from "./dto/empstartdateenddate.request";
import { Between, getManager } from "typeorm";
import { AttendanceMonthRequest } from "./dto/month.request";
import { AttendanceAdjustRequest } from "./dto/attendance-adjustment.request";
import { equals } from "class-validator";
import { EmployeeCodesRequest } from "./dto/emp-codes.request";
import { LeaveUpdateRequest } from "./dto/leave-update.request";
import moment from "moment";
import { AttendanceAdjustmentRepository } from "./repository/attendance-adjustment.repository";
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { AttnAdjustLogReq } from "./dto/attn-adjust-log.request";
import { AttendanceAdjustmentAdapter } from "./dto/attn-adjust.adapter";
import { AttendanceAdjustment } from "./entities/attendance-adjustment.entity";
import { OverTimeService } from "@gtpl/shared-services/hrms";
import { UnitcodeService } from "@gtpl/shared-services/masters";
import appSettings from "apps/services/config";
import { DateReq } from "./dto/date.request";

@Injectable()
export class AttendanceService {
    constructor(
        private attendanceLogRepo: AttendanceLogRepository,
        private AttendanceLogAdapter: AttendanceLogAdapter,
        private attendanceRepo: AttendanceRepository,
        private AttendanceAdapter: AttendanceAdapter,
        private attendanceAdjustmentAdapter: AttendanceAdjustmentAdapter,
        private attendanceHelperService: AttendanceHelperService,
        private overTimeService: OverTimeService,
        private unitCodeService: UnitcodeService,
    ) { }

    async createAttendanceLogs(attnLogReq: AttendanceLogRequest): Promise<AttendanceLogResponse> {
        const convertedAttnLogEntity: AttendanceLogEntity = this.AttendanceLogAdapter.convertDtoToEntity(attnLogReq);
        const savedAttenLogEntity: AttendanceLogEntity = await this.attendanceLogRepo.save(convertedAttnLogEntity);
        const savedAttnLogModel: AttendanceLogModel = this.AttendanceLogAdapter.convertEntityToDto(savedAttenLogEntity);
        if (savedAttnLogModel) {
            const response = new AttendanceLogResponse(true, 11101, ' Logged Successfully', [savedAttnLogModel]);
            return response;
        } else {
            return new AttendanceLogResponse(false, 11106, ' saved but issue while transforming into DTO');
        }
    }

    @Cron('*/15 * * * *')
    async createAttendance(): Promise<AttendanceResponse> {
        const records = await this.attendanceLogRepo.getNonProcessedAttendanceLogs();
        if (records.length == 0) {
            return new AttendanceResponse(false, 11101, 'No logs found');
        } else {
            for (const record of records) {
                const empCode = record.employee_code;
                const date = moment(record.log_date).format('YYYY-MM-DD');
                const prevDate = moment(record.log_date).subtract(1, 'day').format('YYYY-MM-DD');
                const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
                const empRecord1 = await this.attendanceRepo.getEmpAttendanceRecordByDate(prevDate, empCode);
                if (!empRecord && !empRecord1) {
                    const emp = await this.attendanceHelperService.getEmployeeActiveInactive(empCode);
                    if (emp.status) {
                        if (!(emp.data.isActive)) {
                            await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
                        } else {
                            continue;
                        }
                    } else {
                        continue;
                    }
                } else {
                    const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
                    if (empInfo) {
                        if (!empRecord1 && empRecord) {
                            const time = moment(record.log_date).format('HH:mm:ss');
                            const inTime = moment(empRecord.in_time).format('HH:mm:ss');
                            const outTime = moment(empRecord.out_time).format('HH:mm:ss');
                            if (equals(empRecord.shift, 'C Shift')) {
                                const startDate = new Date('2022-11-20 21:00:00')
                                const startTime = moment(startDate).format('HH:mm:ss');
                                const date1 = new Date('2022-11-18 23:59:59');
                                const time1 = moment(date1).format('HH:mm:ss');
                                if (startTime <= time && time <= time1 && empRecord.present_status == 'A') {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date })
                                } else {
                                    if (startTime <= time && time <= time1 && empRecord.present_status == 'P') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    } else {
                                        continue
                                    }
                                }
                            } else if (equals(empRecord.shift, 'X Shift')) {
                                const nDate = new Date('2022-1-3 16:00:00')
                                const nTime = moment(nDate).format('HH:mm:ss');
                                if (empRecord.present_status == 'A') {
                                    if (time < nTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                    } else {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, flag: 1 });
                                    }
                                } else if (empRecord.present_status == 'P') {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                } else {
                                    continue;
                                }
                            } else if (equals(empRecord.shift, 'X1 Shift')) {
                                const nDate = new Date('2022-1-3 16:00:00')
                                const nTime = moment(nDate).format('HH:mm:ss');
                                if (empRecord.present_status == 'A') {
                                    if (time < nTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                    } else {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, flag: 1 });
                                    }
                                } else if (empRecord.present_status == 'P') {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                } else {
                                    continue;
                                }
                            } else {
                                if (empRecord.present_status == 'A') {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                } else if (empRecord.present_status == 'P') {
                                    if (time < inTime && inTime > outTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
                                    } else if (time < inTime && inTime < outTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
                                    }
                                    // else if (time > inTime && time < outTime) {
                                    //     await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
                                    // } 
                                    else {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else {
                                    continue;
                                }
                            }
                            // update log status to processed 
                            await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
                        } else if (empRecord && empRecord1) {
                            const time = moment(record.log_date).format('HH:mm:ss');
                            const inTime = moment(empRecord.in_time).format('HH:mm:ss');
                            const outTime = moment(empRecord.out_time).format('HH:mm:ss');
                            if (equals(empRecord.shift, 'C Shift')) {
                                //const startTime = moment(shift.data[0].inTime).format('HH:mm:ss');
                                const startDate = new Date('2022-11-20 21:00:00')
                                const startTime = moment(startDate).format('HH:mm:ss');
                                //const endTime = moment(shift.data[0].outTime).format('HH:mm:ss');
                                const endDate = new Date('2022-11-20 06:59:00')
                                const endTime = moment(endDate).format('HH:mm:ss');
                                const date1 = new Date('2022-11-18 23:59:59');
                                const time1 = moment(date1).format('HH:mm:ss');
                                if (startTime <= time && time <= time1 && empRecord.present_status == 'A') {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date })
                                } else if (time <= endTime && empRecord1.present_status == 'A') {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                } else {
                                    if (startTime <= time && time <= time1 && empRecord.present_status == 'P') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    } else if (time <= endTime && empRecord1.present_status == 'P') {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                    } else {
                                        continue
                                    }
                                }
                            } else if (equals(empRecord.shift, 'X Shift')) {
                                let readFlag = 0;
                                const endDate = new Date('2022-11-20 09:59:00')
                                const endTime = moment(endDate).format('HH:mm:ss');
                                const mDate = new Date('2022-11-20 03:59:00')
                                const mTime = moment(mDate).format('HH:mm:ss');
                                // const date1 = moment.utc(record.log_date);
                                // const date2 = moment.utc(record.log_date).add(9, 'hours');
                                // const day1 = date1.date();
                                // const day2 = date2.date();
                                const nDate = new Date('2022-1-3 16:00:00')
                                const nTime = moment(nDate).format('HH:mm:ss');
                                if (empRecord.present_status == 'A' && time > nTime) {
                                    readFlag = 1;
                                }
                                if (empRecord.present_status == 'A') {
                                    if (time < mTime) {
                                        if (empRecord1.present_status == 'P') {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                        } else {
                                            continue;
                                        }
                                    } else if (time < endTime) {
                                        if (empRecord1.flag == 1) {
                                            if (empRecord1.present_status == 'P') {
                                                await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                            } else {
                                                await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, outTime: record.log_date });
                                            }
                                        } else {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                        }
                                    } else {
                                        if (readFlag == 0) {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                        } else if (readFlag == 1) {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, flag: 1 });
                                        }
                                    }
                                } else if (empRecord.present_status == 'P' && empRecord1.flag == 0) {
                                    if (time < inTime && inTime > outTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
                                    } else if (time < inTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
                                    } else {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'P' && empRecord.flag == 0) {
                                    if (time < inTime && inTime > outTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
                                    } else if (time < inTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
                                    } else {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    };
                                } else if (empRecord.present_status == 'P' && empRecord.flag == 1) {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                } else {
                                    continue;
                                }
                            } else if (equals(empRecord.shift, 'X1 Shift')) {
                                let readFlag = 0;
                                const endDate = new Date('2022-11-20 10:59:00')
                                const endTime = moment(endDate).format('HH:mm:ss');
                                const mDate = new Date('2022-11-20 03:59:00')
                                const mTime = moment(mDate).format('HH:mm:ss');
                                // const date1 = moment.utc(record.log_date);
                                // const date2 = moment.utc(record.log_date).add(12, 'hours');
                                // const day1 = date1.date();
                                // const day2 = date2.date();
                                const nDate = new Date('2022-1-3 16:00:00');
                                const nTime = moment(nDate).format('HH:mm:ss');
                                if (empRecord.present_status == 'A' && time > nTime) {
                                    readFlag = 1;
                                }
                                if (empRecord.present_status == 'A') {
                                    if (time < mTime) {
                                        if (empRecord1.present_status == 'P') {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                        } else {
                                            continue;
                                        }
                                    } else if (time < endTime) {
                                        if (empRecord1.flag == 1) {
                                            if (empRecord1.present_status == 'P') {
                                                await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { outTime: record.log_date });
                                            } else {
                                                await this.attendanceRepo.update({ employeeCode: empCode, date: prevDate }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, outTime: record.log_date });
                                            }
                                        } else {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                        }
                                    } else {
                                        if (readFlag == 0) {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                        } else if (readFlag == 1) {
                                            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date, flag: 1 });
                                        }
                                    }
                                } else if (empRecord.present_status == 'P' && empRecord1.flag == 0) {
                                    if (time < inTime && inTime > outTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
                                    } else if (time < inTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
                                    } else {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else if (empRecord.present_status == 'P' && empRecord.flag == 0) {
                                    if (time < inTime && inTime > outTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
                                    } else if (time < inTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
                                    } else {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    };
                                } else if (empRecord.present_status == 'P' && empRecord.flag == 1) {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                } else {
                                    continue;
                                }
                            } else {
                                if (empRecord.present_status == 'A') {
                                    await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { logDate: record.log_date, downloadDate: record.download_date, deviceCode: record.device_code, verifyMode: record.verify_mode, presentStatus: 'P', inTime: record.log_date });
                                } else if (empRecord.present_status == 'P') {
                                    if (time < inTime && inTime > outTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date, outTime: empRecord.in_time });
                                    } else if (time < inTime && inTime < outTime) {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { inTime: record.log_date });
                                    }
                                    // else if (time > inTime && time < outTime) {
                                    //     await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
                                    // } 
                                    else {
                                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { outTime: record.log_date });
                                    }
                                } else {
                                    continue;
                                }
                            }
                            // update log status to processed 
                            await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
                        } else {
                            continue;
                        }
                    } else {
                        continue;
                        // await this.attendanceLogRepo.update({ attendaceLogId: record.attendace_log_id }, { status: true });
                    }
                }
            }
            return new AttendanceResponse(true, 11101, 'Logged Successfully');
        }
    }

    async attendanceAdjustment(attnAdjustLogReq: AttnAdjustLogReq): Promise<any> {
        const transManager = new GenericTransactionManager();
        const req = new AttendanceAdjustRequest();
        req.employeeCode = attnAdjustLogReq.employeeCode;
        req.date = attnAdjustLogReq.date;
        const appliedDate = new Date();
        const attnData = await this.getAdjustmentData(req);
        await transManager.startTransaction();
        const attnAdjust = await transManager.getCustomRepository(AttendanceAdjustmentRepository).findOne({ where: { employeeCode: attnAdjustLogReq.employeeCode, date: req.date } })
        if (attnAdjust) {
            const attnAdjustUpdate = await transManager.getCustomRepository(AttendanceAdjustmentRepository).update({ employeeCode: attnAdjustLogReq.employeeCode, date: req.date }, { inTime: attnAdjustLogReq.inTime, outTime: attnAdjustLogReq.outTime, presentStatus: attnAdjustLogReq.presentStatus, reason: attnAdjustLogReq.reason, remarks: attnAdjustLogReq.remarks, updatedUser: attnAdjustLogReq.user, status: LeaveApprovalStatusEnum.OPEN });
            if (attnAdjustUpdate.affected) {
                await transManager.completeTransaction();
                return new GlobalResponseObject(true, 11105, "Attendance adjustment updated for this employee for the date" + req.date);
            } else {
                await transManager.releaseTransaction();
                return new GlobalResponseObject(false, 11106, 'Something Went Wrong In Attendance update');
            }
        } else {
            const convertedAttnLogEntity: AttendanceAdjustment = this.attendanceAdjustmentAdapter.convertDtoToEntity(attnData.data.employeeId, attnData.data.employeeCode, attnData.data.employeeName, req.date, attnData.data.inTime, attnAdjustLogReq.inTime, attnData.data.outTime, attnAdjustLogReq.outTime, attnAdjustLogReq.presentStatus, attnData.data.departmentId, attnData.data.shiftGroup, attnData.data.unitId, attnData.data.shift, attnAdjustLogReq.reason, attnAdjustLogReq.remarks, appliedDate, attnAdjustLogReq.user);
            const savedAttenLogEntity = await transManager.getCustomRepository(AttendanceAdjustmentRepository).save(convertedAttnLogEntity);
            if (savedAttenLogEntity) {
                // const savedAttnLogModel: AttendanceAdjustmentDto = this.attendanceAdjustmentAdapter.convertEntityToDto(savedAttenLogEntity);
                await transManager.completeTransaction();
                return new GlobalResponseObject(true, 11101, ' Attendance adjustment applied Successfully');
            } else {
                await transManager.releaseTransaction();
                return new GlobalResponseObject(false, 11106, 'Something Went Wrong In Attendance Saving');
            }
        }
    }

    async getAttnAdjustTableData(): Promise<CommonResponse> {
        const transManager = new GenericTransactionManager();
        await transManager.startTransaction();
        const datas = await transManager.getCustomRepository(AttendanceAdjustmentRepository).find({ order: { appliedDate: 'DESC' } });
        if (datas) {
            await transManager.completeTransaction();
        } else {
            await transManager.releaseTransaction()
        }
        const response = [];
        for (const data of datas) {
            const tableData = this.attendanceAdjustmentAdapter.convertEntityToDto(data);
            response.push(tableData);
        }
        if (response) {
            return new CommonResponse(true, 11107, 'Data retrieved successfully', response);
        } else {
            await transManager.releaseTransaction();
            return new CommonResponse(false, 11106, ' Data not Found ');
        }
    }

    async updateAttendance(attnUpdateReq: AttendanceUpdateRequest): Promise<AttendanceResponse> {
        const date = attnUpdateReq.date;
        const empCode = attnUpdateReq.employeeCode;
        const transManager = new GenericTransactionManager();
        const currDate = new Date();
        const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
        if (empRecord) {
            await transManager.startTransaction();
            if (attnUpdateReq.status == LeaveApprovalStatusEnum.APPROVED) {
                const attenUpdate = await transManager.getCustomRepository(AttendanceRepository).update({ employeeCode: empCode, date: date }, { logDate: currDate, downloadDate: date, deviceCode: 'Manual', verifyMode: 'Manual', presentStatus: attnUpdateReq.presentStatus, inTime: attnUpdateReq.inTime, outTime: attnUpdateReq.outTime, updatedUser: attnUpdateReq.user });
                if (attenUpdate.affected) {
                    const attenAdjUpdate = await transManager.getCustomRepository(AttendanceAdjustmentRepository).update({ employeeCode: empCode, date: date }, { status: LeaveApprovalStatusEnum.APPROVED, updatedUser: attnUpdateReq.user });
                    if (attenAdjUpdate.affected) {
                        await transManager.completeTransaction();
                        return new AttendanceResponse(true, 11101, 'Attendance Approved and Updated Successfully');
                    } else {
                        await transManager.releaseTransaction();
                        return new AttendanceResponse(false, 11101, 'Something went wrong in attendance adjustment updation');
                    }
                } else {
                    await transManager.releaseTransaction();
                    return new AttendanceResponse(false, 11101, 'Something went wrong in attendance updation');
                }
            } else if (attnUpdateReq.status == LeaveApprovalStatusEnum.REJECTED) {
                const rejUpdate = await transManager.getCustomRepository(AttendanceAdjustmentRepository).update({ employeeCode: empCode, date: date }, { status: LeaveApprovalStatusEnum.REJECTED, updatedUser: attnUpdateReq.user });
                if (rejUpdate.affected) {
                    await transManager.completeTransaction();
                    return new AttendanceResponse(true, 11101, 'Attendance Rejected Successfully');
                } else {
                    await transManager.releaseTransaction();
                    return new AttendanceResponse(false, 11101, 'Something went wrong in rejection of attendance');
                }
            }
        }
        else {
            return new AttendanceResponse(false, 11106, 'Record already updated for this Employee');
        }
    }

    async updateLeave(req: LeaveUpdateRequest): Promise<AttendanceResponse> {
        const fromDate = new Date(req.fromDate);
        const toDate = new Date(req.toDate);
        const empCode = req.employeeCode;
        const fromDay = req.fromDay;
        const toDay = req.toDay;
        for (var i = new Date(fromDate); i <= new Date(toDate); i.setDate(i.getDate() + 1)) {
            const date1 = i.getFullYear() + '-' + (Number(i.getMonth()) + 1) + '-' + i.getDate();
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date1, empCode);
            if (empRecord.present_status == 'A') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date1 }, { presentStatus: 'L' });
            } else if (empRecord.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date1 }, { presentStatus: 'H' });
            }
        }
        if (fromDay === "First Half" || fromDay === "Second Half") {
            const date = fromDate.getFullYear() + '-' + (Number(fromDate.getMonth()) + 1) + '-' + fromDate.getDate()
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
            if (empRecord.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { presentStatus: 'H' });
            } else {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { leaveStatus: 'HDL' });
            }
        } else if (toDay === "First Half" || toDay === "Second Half") {
            const date = toDate.getFullYear() + '-' + (Number(toDate.getMonth()) + 1) + '-' + toDate.getDate()
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
            if (empRecord.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { presentStatus: 'H' });
            } else {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { leaveStatus: 'HDL' });
            }
        } else if ((fromDay === "First Half" || fromDay === "Second Half") && (toDay === "First Half" || toDay === "Second Half")) {
            const date = fromDate.getFullYear() + '-' + (Number(fromDate.getMonth()) + 1) + '-' + fromDate.getDate()
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
            if (empRecord.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { presentStatus: 'H' });
            } else {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { leaveStatus: 'HDL' });
            }
            const date1 = toDate.getFullYear() + '-' + (Number(toDate.getMonth()) + 1) + '-' + toDate.getDate()
            const empRecord1 = await this.attendanceRepo.getEmpAttendanceRecordByDate(date1, empCode);
            if (empRecord1.present_status == 'H') {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date1 }, { presentStatus: 'H' });
            } else {
                await this.attendanceRepo.update({ employeeCode: empCode, date: date1 }, { leaveStatus: 'HDL' });
            }
        }
        return new AttendanceResponse(true, 11101, 'Leave updated successfully')
    }

    async updateEmpLogsByShift(req: EmpCodeShiftRequest): Promise<AttendanceResponse> {
        const empCodes = req.employeeCodes;
        const shiftCode = req.shiftCode;
        for (const empCode of empCodes) {
            const records = await this.attendanceHelperService.getTeamCalenderRecords(shiftCode);
            for (const record of records) {
                const dateOne = new Date(req.fromDate);
                const dateTwo = new Date(req.toDate);
                for (var i = dateOne; i <= dateTwo; i.setDate(i.getDate() + 1)) {
                    const date = i.getFullYear() + '-' + (Number(i.getMonth()) + 1) + '-' + i.getDate();
                    const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
                    if (empRecord) {
                        await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { shiftGroup: shiftCode, shift: record.shift });
                    } else {
                        return new AttendanceResponse(false, 111101, 'Could not find employee record');
                    }
                }
            }
        }
        return new AttendanceResponse(true, 11101, 'Updated successfully');
    }

    // async createEmpAttendanceLogs(req: EmployeeCodesRequest): Promise<AttendanceResponse> {
    //     const empCodes = req.employeeCodes;
    //     for (const empCode of empCodes) {
    //         const currDate = new Date();
    //         const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + currDate.getDate();
    //         const dateOne = new Date(2023, 1, 1);
    //         const dateTwo = new Date(2023, 3, 27);
    //         const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
    //         if (!empInfo) {
    //             continue;
    //         }
    //         let shift = '';
    //         if (empInfo.employeeType == 'Labour Form') {
    //             shift = 'X Shift'
    //         }
    //         let flagMap = new Set<boolean>();
    //         for (var i = dateOne; i <= dateTwo; i.setDate(i.getDate() + 1)) {
    //             console.log(empCode)
    //             const date1 = i.getFullYear() + '-' + (Number(i.getMonth()) + 1) + '-' + i.getDate();
    //             const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date1, empCode);
    //             if (!empRecord) {
    //                 // check and get the employee based on empCode
    //                 const empAttnEnt = this.AttendanceAdapter.getAttendanceEntity(empInfo.employeeId, date1, null, empCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, null, null, 'A', null, null, null, shift, Number(empInfo.departmentId), null, empInfo.designation, empInfo.unitId, i.getDate(), (Number(i.getMonth()) + 1), i.getFullYear());
    //                 const saveEntity = await this.attendanceRepo.save(empAttnEnt);
    //                 if (saveEntity) {
    //                     flagMap.add(true);
    //                 } else {
    //                     flagMap.add(false);
    //                     break;
    //                 }
    //             } else {
    //                 continue;
    //             }
    //             if (!flagMap.has(false)) {
    //                 continue;
    //             } else {
    //                 return new AttendanceResponse(false, 1111, 'Something went wrong while creating logs');
    //             }
    //         }
    //     }
    //     return new AttendanceResponse(true, 11101, 'Logs created successfully');
    // }


    @Cron('0 23 * * *')
    async createEmpAttendanceLogs(req?: EmployeeCodesRequest): Promise<AttendanceResponse> {
        const empCodes = [];
        const empDetails = await this.attendanceHelperService.getAllActiveEmployees();
        for (const empDetail of empDetails) {
            empCodes.push(empDetail.employeeCode);
        }
        const currDate = new Date();
        const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + currDate.getDate();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const nextDate = tomorrow.getFullYear() + '-' + (Number(tomorrow.getMonth()) + 1) + '-' + tomorrow.getDate();
        for (const empCode of empCodes) {
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(nextDate, empCode);
            if (!empRecord) {
                // check and get the employee based on empCode
                const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
                if (!empInfo) {
                    continue;
                }
                let shift = '';
                if (empInfo.employeeType == 'Labour Form') {
                    shift = 'X Shift'
                }
                const empAttnEnt = this.AttendanceAdapter.getAttendanceEntity(empInfo.employeeId, nextDate, null, empCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, null, null, 'A', null, null, null, shift ? shift : empInfo.shiftGroup, Number(empInfo.departmentId), null, empInfo.designation, empInfo.unitId, tomorrow.getDate(), (Number(tomorrow.getMonth()) + 1), tomorrow.getFullYear());
                const saveEntity = await this.attendanceRepo.save(empAttnEnt);
                if (saveEntity) {
                    continue;
                } else {
                    return new AttendanceResponse(false, 1111, 'Something went wrong while creating logs');
                }
            } else {
                continue;
                // return new AttendanceResponse(false, 1111, 'Logs Already Created for this Employee');
            }
        }
        return new AttendanceResponse(true, 11101, 'Logs created successfully');
    }

    async createEmpAttnLogForToday(req?: EmployeeCodesRequest): Promise<AttendanceResponse> {
        const empCodes = [];
        const empDetails = await this.attendanceHelperService.getAllActiveEmployees();
        for (const empDetail of empDetails) {
            empCodes.push(empDetail.employeeCode);
        }
        const currDate = new Date();
        const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + currDate.getDate();
        for (const empCode of empCodes) {
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
            if (!empRecord) {
                // check and get the employee based on empCode
                const empInfo = await this.attendanceHelperService.getEmployeeByEmpCode(empCode);
                if (!empInfo) {
                    continue;
                }
                let shift = '';
                if (empInfo.employeeType == 'Labour Form') {
                    shift = 'X Shift'
                }
                const empAttnEnt = this.AttendanceAdapter.getAttendanceEntity(empInfo.employeeId, date, null, empCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, null, null, 'A', null, null, null, shift ? shift : empInfo.shiftGroup, Number(empInfo.departmentId), null, empInfo.designation, empInfo.unitId, currDate.getDate(), (Number(currDate.getMonth()) + 1), currDate.getFullYear());
                const saveEntity = await this.attendanceRepo.save(empAttnEnt);
                if (saveEntity) {
                    continue;
                } else {
                    return new AttendanceResponse(false, 1111, 'Something went wrong while creating logs');
                }
            } else {
                continue;
                // return new AttendanceResponse(false, 1111, 'Logs Already Created for this Employee');
            }
        }
        return new AttendanceResponse(true, 11101, 'Log created successfully');
    }

    async getDataForEmpShiftMapping(): Promise<EmployeeDataModelResponse> {
        const empInfos = await this.attendanceHelperService.getAllActiveEmployees();
        const empDataModel: EmployeeDataModel[] = [];
        const deptInfo = await this.attendanceHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
        for (const empInfo of empInfos) {
            const currDate = new Date();
            const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + Number(currDate.getDate());
            const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empInfo.employeeCode);
            const empData = new EmployeeDataModel(empInfo.employeeId, empInfo.employeeCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, empInfo.designation, deptNameMap.get(empRecord.department_id), empRecord.shift_group);
            empDataModel.push(empData);
        }
        return new EmployeeDataModelResponse(true, 11101, 'Data retrived successfully', empDataModel);
    }

    async getAllNonProcessedAttendanceLogs(): Promise<AttendanceLogResponse> {
        try {
            const attnLogDto: AttendanceLogModel[] = [];
            const attnLogEntities: AttendanceLogEntity[] = await this.attendanceLogRepo.find({
                order: { 'logDate': 'DESC' }, where: { status: false }
            });
            if (attnLogEntities) {
                attnLogEntities.forEach(attnLogEntitiy => {
                    const convertedattnLogDto: AttendanceLogModel = this.AttendanceLogAdapter.convertEntityToDto(attnLogEntitiy);
                    attnLogDto.push(convertedattnLogDto);
                });
                return new AttendanceLogResponse(true, 11101, 'Data retrived successfully', attnLogDto);
            } else {
                return new AttendanceLogResponse(false, 99998, 'No Logs found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAttendanceData(empAttnReq: EmployeeAttendanceRequest): Promise<EmployeeAttendanceResponse> {
        const date = empAttnReq.date;
        const deptId = empAttnReq.departmentId;
        const empAttenResponseMap = new Map<number, EmployeeDataModel[]>();
        const records = await this.attendanceRepo.getAttendanceRecordsByDate(date, deptId);
        if (records.length == 0) {
            return new EmployeeAttendanceResponse(false, 0, 'No data found');
        }
        const deptInfo = await this.attendanceHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
        const empsInfo = await this.attendanceHelperService.getAllActiveEmployees();
        const empsInfoMap = new Map<number, EmployeeDto>();
        empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
        for (const record of records) {
            const empId = Number(record.employee_id);
            const empInfo = empsInfoMap.get(empId);
            if (!empAttenResponseMap.has(record.department_id)) {
                empAttenResponseMap.set(record.department_id, []);
            }
            empAttenResponseMap.get(record.department_id).push(new EmployeeDataModel(empInfo.employeeId, empInfo.employeeCode, empInfo.employeeName, empInfo.designation));
        }
        const empsModelArray: DeptWiseDataModel[] = [];
        for (const [key, empDetailes] of empAttenResponseMap) {
            const empCount = await this.attendanceRepo.getDeptEmpCountShiftWise(date, key);
            const totalCount = empCount.count;
            let presentCount = 0;
            empDetailes.forEach(emp => presentCount = presentCount + 1);
            empsModelArray.push(new DeptWiseDataModel(key, deptNameMap.get(key), empDetailes, totalCount, presentCount));
        }
        return new EmployeeAttendanceResponse(true, 0, 'Retrieved successfully', empsModelArray);
    }

    async getAttendanceDataShiftWise(empAttnReq: EmployeeAttendanceRequest): Promise<EmployeeShiftAttendanceResponse> {
        const date = empAttnReq.date;
        const shift = empAttnReq.shift;
        const unitId = empAttnReq.unitId;
        const empAttenResponseMap = new Map<string, DeptDataModel[]>();
        const records = await this.attendanceRepo.getAttendanceRecordsByDateAndShift(date, shift, unitId);
        if (records.length == 0) {
            return new EmployeeShiftAttendanceResponse(false, 0, 'No data found');
        }
        const deptInfo = await this.attendanceHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
        const empsInfo = await this.attendanceHelperService.getAllActiveEmployees();
        const empsInfoMap = new Map<number, EmployeeDto>();
        empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
        for (const record of records) {
            if (!empAttenResponseMap.has(record.shift)) {
                empAttenResponseMap.set(record.shift, []);
            }
            const empCount = await this.attendanceRepo.getDeptEmpCountShiftWise(date, record.department_id, record.shift);
            const totalCount = empCount.count;
            empAttenResponseMap.get(record.shift).push(new DeptDataModel(record.department_id, deptNameMap.get(record.department_id), totalCount, record.count));
        }
        const empsModelArray: ShiftWiseDataModel[] = [];
        for (const [key, deptDetailes] of empAttenResponseMap) {
            empsModelArray.push(new ShiftWiseDataModel(key, deptDetailes));
        }
        return new EmployeeShiftAttendanceResponse(true, 0, 'Retrieved successfully', empsModelArray);
    }

    async getAttendanceCountShiftWise(shiftAttnReq: ShiftAttendanceRequest): Promise<EmployeeShiftCountResponse> {
        const fromDate = shiftAttnReq.fromDate;
        const toDate = shiftAttnReq.toDate;
        const shift = shiftAttnReq.shift;
        const empAttenResponseMap = new Map<string, AttnCountModel[]>();
        const records = await this.attendanceRepo.getShiftWiseAttendanceByDate(fromDate, toDate);
        if (records.length == 0) {
            return new EmployeeShiftCountResponse(false, 0, 'No data found');
        }
        for (const record of records) {
            if (!empAttenResponseMap.has(record.shift)) {
                empAttenResponseMap.set(record.shift, []);
            }
            const date = record.log_date.getFullYear() + '-' + (Number(record.log_date.getMonth()) + 1) + '-' + record.log_date.getDate();
            const empCount = await this.attendanceRepo.getShiftWiseEmpCountByDate(date, record.shift);
            let totalCount = 0;
            for (const emp of empCount) {
                totalCount = emp.count;
            }
            empAttenResponseMap.get(record.shift).push(new AttnCountModel(date, totalCount, record.count));
        }
        const empsModelArray: ShiftWiseCountModel[] = [];
        for (const [key, attnDetailes] of empAttenResponseMap) {
            empsModelArray.push(new ShiftWiseCountModel(key, attnDetailes));
        }
        return new EmployeeShiftCountResponse(true, 0, 'Retrieved successfully', empsModelArray);
    }

    async getMonthWiseAttendanceReport(monthReq: AttendanceMonthRequest): Promise<MonthAttendanceResponse> {
        try {
            const month = monthReq.month;
            const deptId = monthReq.departmentId;
            const unitId = monthReq.unitId;
            const empAttenResponseMap = new Map<number, MonthAttnDataModel>();
            const records = await this.attendanceRepo.getAttendanceRecordsByMonth(month, deptId, unitId);
            if (records.length == 0) {
                return new MonthAttendanceResponse(false, 0, 'No data found');
            }
            const unitInfo = await this.attendanceHelperService.getAllUnitcodes();
            const unitNameMap = new Map<number, string>();
            unitInfo.forEach(unit => unitNameMap.set(unit.unitcodeId, unit.unitcodeName));
            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const empsInfo = await this.attendanceHelperService.getAllEmployees();
            const empsInfoMap = new Map<number, EmployeeDto>();
            empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
            const otHoursInfo = await this.overTimeService.getOTHoursByEmployeeCode(monthReq);
            const otHoursInfoMap = new Map<string, number>();
            otHoursInfo.data.forEach(emp => otHoursInfoMap.set(emp.employeeCode, emp.otHours));
            const otShiftInfo = await this.overTimeService.getOTShiftsByEmployeeCode(monthReq);
            const otShiftInfoMap = new Map<string, number>();
            otShiftInfo.data.forEach(emp => otShiftInfoMap.set(emp.employeeCode, emp.otShifts));
            for (const record of records) {
                const empId = Number(record.employee_id);
                const empInfo = empsInfoMap.get(empId);
                if (!empAttenResponseMap.has(empInfo.employeeId)) {
                    const empRecords = await this.attendanceRepo.getMonthRecordsForEmp(empInfo.employeeId, month);
                    let presentCount = 0;
                    let outDoorCount = 0;
                    let absentCount = 0;
                    let workFromHomeCount = 0;
                    let leaveCount = 0;
                    for (const empRecord of empRecords) {
                        if (empRecord.present_status == 'P') {
                            presentCount = empRecord.count;
                        } else if (empRecord.present_status == 'OD') {
                            outDoorCount = empRecord.count
                        } else if (empRecord.present_status == 'A') {
                            absentCount = empRecord.count;
                        } else if (empRecord.present_status == 'L') {
                            leaveCount = empRecord.count;
                        } else if (empRecord.present_status == 'HD') {
                            workFromHomeCount = empRecord.count;
                        }
                    }
                    empAttenResponseMap.set(empInfo.employeeId, new MonthAttnDataModel(empInfo.employeeCode, empInfo.employeeName + ' ' + empInfo.employeeLastName, deptNameMap.get(record.department_id), empInfo.contractorName, record.shift, empInfo.workstationNumber, [], Number(Number(presentCount) + Number(outDoorCount)), Number(absentCount), Number(workFromHomeCount), Number(leaveCount), unitNameMap.get(empInfo.unitId), otHoursInfoMap.get(empInfo.employeeCode), otShiftInfoMap.get(empInfo.employeeCode)));
                }
                empAttenResponseMap.get(empInfo.employeeId).dayStatus.push(new DayStatusModel(record.day, record.present_status));
            }
            const monthModelArray: MonthAttnDataModel[] = [];
            empAttenResponseMap.forEach(empAttn => monthModelArray.push(empAttn));
            if (monthModelArray) {
                return new MonthAttendanceResponse(true, 0, 'Retrieved successfully', monthModelArray);
            } else {
                return new MonthAttendanceResponse(false, 0, 'Error in getting data');
            }
        } catch (err) {
            return err;
        }
    }

    async getDepartmentDropForAttReport(req: UnitRequest): Promise<CommonResponse> {

        return new CommonResponse(true, 44545, 'Retrieved successfully')
    }

    async getAllEmpDateAtten(req: EmployeeAttDateRequest): Promise<AttendanceResponse> {
        try {
            const attenDtos: AttendanceModel[] = [];
            let empEntities: AttendanceEntity[] = [];
            const empInfo = await this.attendanceHelperService.getAllEmployees();
            const empNameMap = new Map<number, string>();
            empInfo.forEach(emp => empNameMap.set(emp.employeeId, emp.reportingManager));
            const contNameMap = new Map<number, string>();
            empInfo.forEach(emp => contNameMap.set(emp.employeeId, emp.contractorName));
            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const unitInfo = await this.unitCodeService.getAllActiveUnitcode();
            const unitNameMap = new Map<number, string>();
            unitInfo.data.forEach(unit => unitNameMap.set(unit.unitcodeId, unit.unitcodeName));
            if (req.employeeCode) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode } });
            } else if (req.departmentId && req.employeeCode) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode, departmentId: req.departmentId } });
            } else if (req.departmentId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), departmentId: req.departmentId } });
            } else if (req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), unitId: req.unitId } });
            } else if (req.shift) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), shift: req.shift } });
            } else if (req.shift && req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), shift: req.shift, unitId: req.unitId } });
            } else if (req.departmentId && req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), departmentId: req.departmentId, unitId: req.unitId } });
            } else if (req.departmentId && req.employeeCode && req.shift) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode, departmentId: req.departmentId, shift: req.shift } });
            } else if (req.departmentId && req.employeeCode && req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode, departmentId: req.departmentId, unitId: req.unitId } });
            } else if (req.departmentId && req.employeeCode && req.shift && req.unitId) {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate), employeeCode: req.employeeCode, departmentId: req.departmentId, shift: req.shift, unitId: req.unitId } });
            } else {
                empEntities = await this.attendanceRepo.find({ order: { employeeCode: 'ASC', date: 'ASC' }, where: { isActive: true, date: Between(req.startDate, req.endDate) } });
            }
            if (empEntities) {
                empEntities.forEach(Entity => {
                    const convertedEntity: AttendanceModel = this.AttendanceAdapter.convertEntityToDto(Entity);
                    convertedEntity.departmentCode = deptNameMap.get(convertedEntity.departmentId);
                    convertedEntity.reportingManager = empNameMap.get(convertedEntity.employeeId);
                    convertedEntity.unitId = unitNameMap.get(convertedEntity.unitId);
                    convertedEntity.contractorName = contNameMap.get(convertedEntity.employeeId) ? contNameMap.get(convertedEntity.employeeId) : null;
                    convertedEntity.workingHours = convertedEntity.outTime ? moment.utc(moment(convertedEntity.outTime).diff(moment(convertedEntity.inTime))).format('HH:mm') : null;
                    attenDtos.push(convertedEntity);
                });
                return new AttendanceResponse(true, 11108, 'Employees Data Retrieved Successfully', attenDtos);
            } else {
                return new AttendanceResponse(false, 11101, 'Data Not Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAdjustmentData(req: AttendanceAdjustRequest): Promise<AttendanceAdjustResponse> {
        try {
            if (req.employeeCode) {
                const attEntity = await this.attendanceRepo.findOne({ where: { employeeCode: req.employeeCode, date: req.date } });
                if (attEntity) {
                    const convertedEntity: AttendanceModel = this.AttendanceAdapter.convertEntityToDto(attEntity);
                    return new AttendanceAdjustResponse(true, 11108, 'Active Employees retrived', convertedEntity);
                } else {
                    return new AttendanceAdjustResponse(false, 99998, 'Data Not Found')
                }
            }
        } catch (err) {
            return err;
        }
    }

    async getPresentEmployeesData(req: DateReq): Promise<AttendanceResponse> {
        const date = req.date
        const attnModel: AttendanceModel[] = [];
        const deptInfo = await this.attendanceHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
        const attEntities = await this.attendanceRepo.find({ where: { presentStatus: "P", date: date }, order: { employeeCode: 'ASC' } });
        if (attEntities) {
            for (const attnEntity of attEntities) {
                const convertedEntity: AttendanceModel = this.AttendanceAdapter.convertEntityToDto(attnEntity);
                convertedEntity.departmentCode = deptNameMap.get(convertedEntity.departmentId)
                attnModel.push(convertedEntity);
            }
            return new AttendanceResponse(true, 11108, 'Active Employees retrived', attnModel);
        } else {
            return new AttendanceResponse(false, 99998, 'Data Not Found')
        }
    }

    async getPresentEmployeeDataByEmpCode(req: AttendanceAdjustRequest): Promise<AttendanceResponse> {
        const date = req.date;
        const empCode = req.employeeCode;
        const record = await this.attendanceRepo.getEmpAttenRecordByDateEmpCode(date, empCode);
        const attnModel = new AttendanceModel(record.employee_id, record.employee_code, record.employee_name, date, record.in_time, record.out_time);
        return new AttendanceResponse(true, 11101, 'retrived successfully', [attnModel]);
    }

    async getLessWorkingEmployees(): Promise<AttendanceResponse> {

        function getPreviousDay(date = new Date()) {
            const previous = new Date(date.getTime());
            previous.setDate(date.getDate() - 1);
            return previous;
        }
        const ystDate = getPreviousDay();
        const toDate = ystDate.getFullYear() + '-' + (ystDate.getMonth() + 1) + '-' + ystDate.getDate();
        const currDate = new Date();
        const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
        const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
        let monthStartDate = '';
        if (currDate.getDate() == 1) {
            monthStartDate = currDate.getFullYear() + '-' + currDate.getMonth() + '-' + '1';
        } else {
            monthStartDate = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + '1';
        }
        const record = await this.attendanceRepo.getTotalLessWorkingHoursData(monthStartDate, toDate);
        return new AttendanceResponse(true, 11101, 'retrived successfully', record);
    }

    async getCriteriaNotMatchingReport(): Promise<AttendanceResponse> {

        function getPreviousDay(date = new Date()) {
            const previous = new Date(date.getTime());
            previous.setDate(date.getDate() - 1);
            return previous;
        }
        const ystDate = getPreviousDay();
        const toDate = ystDate.getFullYear() + '-' + (ystDate.getMonth() + 1) + '-' + ystDate.getDate();
        const currDate = new Date();
        const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
        const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
        let monthStartDate = '';
        if (currDate.getDate() == 1) {
            monthStartDate = currDate.getFullYear() + '-' + currDate.getMonth() + '-' + '1';
        } else {
            monthStartDate = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + '1';
        }
        const record = await this.attendanceRepo.getCriteriaNotMatchingData(monthStartDate, toDate);
        return new AttendanceResponse(true, 11101, 'retrived successfully', record);
    }

    async updateAttendanceByHR(attnUpdateReq: AttendanceUpdateRequest): Promise<AttendanceResponse> {
        const date = attnUpdateReq.date;
        const empCode = attnUpdateReq.employeeCode;
        const currDate = new Date();
        const empRecord = await this.attendanceRepo.getEmpAttendanceRecordByDate(date, empCode);
        if (empRecord) {
            await this.attendanceRepo.update({ employeeCode: empCode, date: date }, { presentStatus: attnUpdateReq.presentStatus, reason: attnUpdateReq.reason, hrStatus: true, updatedUser: attnUpdateReq.user });
            return new AttendanceResponse(true, 11101, 'Attendance updated successfully');
        } else {
            return new AttendanceResponse(false, 11106, 'Record not found for this Employee');
        }
    }

    async getUnitDropForAttReport(): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT uc.unit_name AS unitName , a.unit_id AS unitId FROM ` + appSettings.hrms_db + `.attendance a 
          LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.unit_id 
          WHERE a.employee_id > 0 AND a.unit_id > 0 GROUP BY a.unit_id `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 1121, 'Data retrived succesfully', data)
        }
        else {
            return new CommonResponse(false, 1121, 'No data found')
        }
    }

    async getShiftDropForAttReport(): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT shift AS shift FROM ` + appSettings.hrms_db + `.attendance
          WHERE shift > '' GROUP BY shift `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 1121, 'Data retrived succesfully', data)
        }
        else {
            return new CommonResponse(false, 1121, 'No data found')
        }
    }

}

